import { render } from "./OtpCodeBoxes.vue?vue&type=template&id=57ef7326&scoped=true"
import script from "./OtpCodeBoxes.vue?vue&type=script&lang=js"
export * from "./OtpCodeBoxes.vue?vue&type=script&lang=js"

import "./OtpCodeBoxes.vue?vue&type=style&index=0&id=57ef7326&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57ef7326"]])

export default __exports__